module.exports = __webpack_public_path__ + "img/weixin.0ac556db.png";